import request from '@webtrader/core/request';

export interface ICountryDetail {
  country: string;
  dialCode: string;
  countryCode: string;
}

const retrieveCountryDetails = () => {
  return request.get<ICountryDetail[]>('/api/account/v1/country');
};

export default retrieveCountryDetails;
